/**
 * gets the value from document.cookie object
 * @param {string} key - name of the cookie
 * @returns {string|null}
 */
const getCookie = (key = "") => {
    if (typeof window === "undefined") {
        return null
    }
    var keyEQ = key + "="
    var ca = document.cookie.split(";")
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === " ") c = c.substring(1, c.length)
        if (c.indexOf(keyEQ) === 0) {
            const value = c.substring(keyEQ.length, c.length)
            try {
                return JSON.parse(decodeURIComponent(value))
            } catch (err) {
                return value
            }
        }
    }
    return null
}

/**
 * sets a new cookie into the document.cookie object
 * @param {string} key - name of the cookie
 * @param {string} value - value of the cookie
 * @param {number} [duration] - in hours
 */
const setCookie = (key, value, duration = 0) => {
    if (typeof window === "undefined") {
        return null
    }
    let expires = ""
    if (duration) {
        const date = new Date()
        date.setTime(date.getTime() + duration * 60 * 60 * 1000)
        expires = "; expires=" + date.toUTCString()
    }
    document.cookie = key + "=" + (value || "") + expires + "; path=/"
}

/**
 * deletes the cookie from document.cookie object
 * @param {string} key - name of the cookie
 */
const deleteCookie = (key) => {
    if (typeof window === "undefined") {
        return null
    }
    document.cookie = key + "=; Max-Age=-99999999; Path=/;"
}

/**
 * clear all cookies defined within document.cookie object
 * excluding HttpOnly cookies, and cookies having path/domain set
 */
const clearCookies = () => {
    if (typeof window === "undefined") {
        return null
    }
    const cookies = document.cookie.split(";")
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i]
        const eqPos = cookie.indexOf("=")
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
        deleteCookie(name)
    }
}

module.exports = {
    getCookie,
    setCookie,
    deleteCookie,
    clearCookies,
}
